
import { Component, Vue } from "vue-property-decorator";
import { roleList } from "@/req/homeIndex";
import NavBar from "@/components/navBar.vue";
@Component({
  components: { NavBar },
})
export default class Logout extends Vue {
  public roleList = [];
  public gameId: any = "";
  public gameName: any = "";
  public serverId: any = "";
  public serverName: any = "";
  //   public obj: any = this.$route.query.obj;
  public created() {
    this.gameName = this.$route.query.gameName;
    this.gameId = this.$route.query.gameid;
    this.serverId = this.$route.query.serverid;
    this.serverName = this.$route.query.serverName;
    this.serverChange();
  }
  public async serverChange() {
    const res = await roleList({
      server_id: this.serverId,
    });
    if (res.code === 200) {
      this.roleList = res.data;
    }
  }
}
